export const LANGUAGE = "LANGUAGE";
export const LICENSING = "LICENSING";
export const DATABASE = "DATABASE";
export const LOGIN = "LOGIN";
export const MACHINE = "MACHINE";
export const PRINTER = "PRINTER";
export const SPECTRO = "SPECTRO";
export const SETTINGS = "SETTINGS";
export const SUMMARY = "SUMMARY";
